export default __webpack_public_path__ + "static/media/download-xls.af582684.svg";